import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

const tileVariants = {
    hidden: { opacity: 0, scale: 0.96 },
    visible: { opacity: 1, scale: 1, transition: { duration: 0.4 } },
};

const TILE =
    "w-full h-full rounded-[3vh] bg-white text-center shadow-[0_0.5vh_2vh_rgba(18,22,31,0.08)] p-[2vh_1.6vw] flex flex-col justify-between";
const LABEL =
    "text-[1.3vh] font-bold tracking-[0.15vh] uppercase text-[#7B8290]";

function WeatherSlide() {
    const { t, i18n } = useTranslation();
    const [weather, setWeather] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        const cachedWeather = JSON.parse(localStorage.getItem("weather"));
        const cacheDuration = 10 * 60 * 1000; // 10 минут

        if (
            cachedWeather &&
            Date.now() - cachedWeather.timestamp < cacheDuration
        ) {
            setWeather(cachedWeather.data);
        } else {
            fetch(
                `https://api.openweathermap.org/data/2.5/weather?q=Karaganda,KZ&appid=89f5814c2add12b90a835d71ad800617&units=metric&lang=${i18n.language}`
            )
                .then((res) => {
                    if (!res.ok) {
                        throw new Error(`Ошибка HTTP: ${res.status}`);
                    }
                    return res.json();
                })
                .then((data) => {
                    setWeather(data);
                    localStorage.setItem(
                        "weather",
                        JSON.stringify({ data, timestamp: Date.now() })
                    );
                })
                .catch((error) => {
                    console.error("Error fetching weather:", error);
                    setError(true);
                });
        }
    }, [i18n.language]);

    if (error) {
        return (
            <motion.div
                className={TILE}
                variants={tileVariants}
                initial="hidden"
                animate="visible"
            >
                <span className={LABEL}>{t("routeList.weather_label")}</span>
                <span className="text-[1.6vh] font-semibold text-[#7B8290] self-end text-right">
                    {t("routeList.weather_error")}
                </span>
            </motion.div>
        );
    }

    if (!weather || !weather.weather) {
        return (
            <motion.div
                className={TILE}
                variants={tileVariants}
                initial="hidden"
                animate="visible"
            >
                <span className={LABEL}>{t("routeList.weather_label")}</span>
                <span className="text-[1.6vh] font-semibold text-[#7B8290] self-end">
                    {t("routeList.weather_loading")}
                </span>
            </motion.div>
        );
    }

    const temp = Math.round(weather.main.temp);

    return (
        <motion.div
            className={TILE}
            variants={tileVariants}
            initial="hidden"
            animate="visible"
        >
            <span className={LABEL}>{t("routeList.weather_label")}</span>
            <span className="text-[3.6vh] font-extrabold tracking-tight self-end leading-none">
                {temp >= 0 ? `+${temp}°` : `${temp}°`}
            </span>
        </motion.div>
    );
}

export default WeatherSlide;
